/**
 * CouponRegisterPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  Table as TableComp,
} from 'components';
import { Select, Input, Button, Radio } from 'antd';
import Formatter from 'utils/Formatter';
import { CouponInfoForm, CouponProductTable } from '../components';

const CouponRegisterPresenter = (props) => {
  const {
    storeData,
    menuData = [],
    couponValue,
    policyValue,
    storeValue,
    menuValue,
    setCouponValue,
    setPolicyValue,
    setStoreValue,
    setMenuValue,
    onStoreChecked,
    onStoreCheckedAll,
    isCheckedStoreAll,
    onMenuChecked,
    onMenuCheckedAll,
    isCheckedMenuAll,
    onSubmit,
    onChange,
    onCancel,
    // NOTE -
    registerType,
    onSelect,
    categories,
    Shops,
  } = props;
  /* ===== ROUTE ===== */
  // console.log('menuData', menuData);
  // console.log('storeData ====>', storeData);
  // console.log('couponValue', couponValue);
  // console.log('policyValue', policyValue);
  // console.log('menuValue', menuValue);
  // console.log('storeValue', storeValue);
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [tableData, setTableData] = React.useState([]);

  /* ===== VARIABLE ===== */
  const hours = [];
  const minute = [];
  for (let i = 0; i < 24; i++) {
    hours.push({ label: `${i.toString().length > 1 ? i : `0${i}`}`, value: i });
  }
  for (let i = 0; i < 60; i += 10) {
    minute.push({
      label: `${i.toString().length > 1 ? i : `0${i}`}`,
      value: i,
    });
  }
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const policyform = [
    {
      key: 'discount_rate',
      label: '할인 설정',
      required: true,
      form: [
        {
          input: (
            <Input
              value={
                policyValue?.discount_rate
                  ? policyValue?.discount_rate
                  : couponValue?.minimum_price === 0
                  ? 0
                  : ''
              }
              size="large"
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.medium }}
              onChange={(e) =>
                onChange(
                  'discount_rate',
                  parseInt(Formatter.numberOnly(e.target.value)),
                  policyValue,
                  setPolicyValue
                )
              }
              disabled={!(couponValue?.voucher_type !== 'EXCHANGE')}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              options={[
                { label: '%', value: 'R' },
                { label: '₩', value: 'W' },
              ]}
              value={
                // policyValue?.discount_type ? policyValue?.discount_type : ''
                couponValue?.voucher_type === 'AMOUNT_DISCOUNT'
                  ? 'W'
                  : couponValue?.voucher_type === 'PERCENT_DISCOUNT'
                  ? 'R'
                  : ''
              }
              disabled
              placeholder="W"
              style={{ ...styles.form.input.medium, width: 80 }}
            />
          ),
        },
      ],
    },
    {
      label: '적립 설정',
      required: true,
      form: [
        {
          input: (
            <Input
              value={
                policyValue?.reserve_rate
                  ? policyValue?.reserve_rate
                  : policyValue?.reserve_rate === 0
                  ? 0
                  : ''
              }
              size="large"
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.medium }}
              onChange={(e) =>
                onChange(
                  'reserve_rate',
                  parseInt(Formatter.numberOnly(e.target.value)),
                  policyValue,
                  setPolicyValue
                )
              }
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              options={[
                { label: '%', value: 'R' },
                { label: '₩', value: 'W' },
              ]}
              value={policyValue?.reserve_type && policyValue?.reserve_type}
              onChange={(e) =>
                onChange('reserve_type', e, policyValue, setPolicyValue)
              }
              placeholder="%"
              style={{ ...styles.form.input.medium, width: 80 }}
            />
          ),
        },
      ],
    },
    {
      label: '최대 할인 금액 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                value={
                  policyValue?.max_discount_price
                    ? policyValue?.max_discount_price
                    : policyValue?.max_discount_price === 0
                    ? 0
                    : ''
                }
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
                onChange={(e) =>
                  onChange(
                    'max_discount_price',
                    parseInt(Formatter.numberOnly(e.target.value)),
                    policyValue,
                    setPolicyValue
                  )
                }
              />
              <p>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '수수료율 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Select
                options={Array.from({ length: 101 }, (_, i) => ({
                  label: i,
                  value: i,
                }))}
                size="large"
                style={{ ...styles.form.input.medium }}
                value={
                  policyValue?.commission_rate && policyValue?.commission_rate
                }
                onChange={(e) =>
                  onChange('commission_rate', e, policyValue, setPolicyValue)
                }
              />
              <p>%</p>
            </>
          ),
        },
      ],
    },
    {
      label: '분담 비율 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Select
                options={Array.from({ length: 101 }, (_, i) => ({
                  label: i,
                  value: i,
                }))}
                size="large"
                style={{ ...styles.form.input.medium }}
                value={policyValue?.share_ratio && policyValue?.share_ratio}
                onChange={(e) =>
                  onChange('share_ratio', e, policyValue, setPolicyValue)
                }
              />
              <p>%</p>
            </>
          ),
        },
      ],
    },
    {
      label: '활성화 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={policyValue?.is_show && policyValue?.is_show}
                onChange={(e) =>
                  onChange(
                    'is_show',
                    e.target.value,
                    policyValue,
                    setPolicyValue
                  )
                }
              >
                <Radio value={'Y'}>활성화</Radio>
                <Radio value={'N'}>비활성화</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 테이블 데이터 정제
   * --
   */
  React.useEffect(() => {
    if (!menuData?.length) return;

    let arr = [];

    switch (registerType) {
      case 'menu':
        if (couponValue?.coupon_type === 'ALL') {
          arr = [...menuData];
        } else if (couponValue?.coupon_type === 'MENU') {
          arr = menuData?.filter((_item) => _item?.type === 'GENERAL');
        } else {
          arr = menuData?.filter(
            (_item) => _item?.type === couponValue?.coupon_type
          );
        }
        break;
      case 'product':
      default:
        arr = [...menuData];
        break;
    }

    setTableData(arr);
  }, [menuData, registerType, couponValue?.coupon_type]);

  /**
   * 쿠폰 타입 변경 시 선택값 초기화
   * --
   */
  React.useEffect(() => {
    setMenuValue([]);
    // eslint-disable-next-line
  }, [couponValue?.coupon_type]);

  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>쿠폰 등록</Title>

          {/* 기본정보 */}
          <CouponInfoForm
            inputValue={couponValue}
            callback={setCouponValue}
            onChange={onChange}
            type={registerType}
          />
          {/* 기본정보 끝 */}

          {/* 혜택 설정 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>혜택 설정</Title>
            <InputFormTable form={policyform} />
          </Content>
          {/* 혜택 설정 */}

          {/* 매장 설정 */}
          {registerType === 'menu' ? (
            <Content maxWidth={'100%'} padding={20} borderRadius={4}>
              <Title style={{ ...styles.subTitle }}>
                사용 불가능 매장 선택
              </Title>

              {/* 매장 테이블 */}
              <div style={{ marginTop: 14 }}>
                <TableComp
                  data={storeData}
                  isChecked
                  columns={[
                    {
                      title: '매장번호',
                      key: 'shop_information_id',
                    },
                    {
                      title: '매장명',
                      key: 'shop_information_name',
                    },
                    {
                      title: '매장설명',
                      key: 'shop_information_content',
                    },
                    {
                      title: '매장 주소',
                      key: 'shop_information_address',
                    },
                    {
                      title: '전화 번호',
                      key: 'business_num',
                    },
                    {
                      title: '매장 타입',
                      key: 'type',
                    },
                  ]}
                  checkedList={storeValue}
                  onChecked={onStoreChecked}
                  checkedAll={isCheckedStoreAll}
                  onCheckedAll={onStoreCheckedAll}
                />
              </div>
              {/* 매장 테이블 끝 */}
            </Content>
          ) : null}

          {/* 매장 설정 끝 */}

          {/* 메뉴 설정 */}
          {couponValue?.coupon_type === 'ALL' ? null : (
            <CouponProductTable
              data={tableData}
              categories={categories}
              shop={Shops}
              selected={menuValue}
              onSelect={onSelect}
              type={registerType}
            />
          )}

          {/* 대상 설정 끝 */}

          {/* 저장/취소 버튼 */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              marginTop: 20,
            }}
          >
            <Button
              size="large"
              type="primary"
              style={{ ...styles.button, background: 'var(--primary-color)' }}
              onClick={() => onSubmit()}
            >
              저장
            </Button>
            <Button
              size="large"
              style={{ ...styles.button }}
              onClick={() => onCancel()}
            >
              취소
            </Button>
          </div>
          {/* 저장/취소 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default CouponRegisterPresenter;
